export default __webpack_public_path__ + "static/media/indicationMemberImg.4c5b39d4.svg";